// Currency helpers: parse and format prices based on detected region.
// No FX conversion — only symbol and position change.

// ISO-3166 alpha-2 codes considered "Europe" for currency display purposes.
const EUROPE_CODES = new Set([
  "AD","AL","AT","BA","BE","BG","BY","CH","CY","CZ","DE","DK","EE","ES","FI",
  "FO","FR","GB","GG","GI","GR","HR","HU","IE","IM","IS","IT","JE","LI","LT",
  "LU","LV","MC","MD","ME","MK","MT","NL","NO","PL","PT","RO","RS","RU","SE",
  "SI","SJ","SK","SM","UA","VA","XK",
]);

export function isEurope(countryCode, continentCode) {
  if ((continentCode || "").toUpperCase() === "EU") return true;
  if (countryCode && EUROPE_CODES.has(String(countryCode).toUpperCase())) return true;
  return false;
}

/** Extract the first numeric token from a string like "$40", "40 €", "40,50". */
export function parseAmount(str) {
  if (str === null || str === undefined) return null;
  const m = String(str).match(/(\d+(?:[.,]\d+)?)/);
  return m ? m[1] : null;
}

/** Format a numeric string according to currency. */
export function formatPrice(amountOrString, currency = "USD") {
  const n = parseAmount(amountOrString);
  if (n === null) return amountOrString;
  return currency === "EUR" ? `${n}\u00a0€` : `$${n}`;
}

/**
 * Replace every occurrence of "$NN" or "NN €" in a string with the
 * appropriate currency symbol/position for the detected region.
 * Used for the plans subtitle that mentions the inscription fee inline.
 */
export function replaceCurrency(text, currency = "USD") {
  if (!text) return text;
  let out = String(text);
  // "$40", "$ 40"
  out = out.replace(/\$\s?(\d+(?:[.,]\d+)?)/g, (_, n) =>
    currency === "EUR" ? `${n}\u00a0€` : `$${n}`
  );
  // "40€", "40 €"
  out = out.replace(/(\d+(?:[.,]\d+)?)\s?€/g, (_, n) =>
    currency === "EUR" ? `${n}\u00a0€` : `$${n}`
  );
  return out;
}
